module.exports = __webpack_public_path__ + "img/advertise.051cf9aa.svg";